import communityHttpClient from './httpClient';
import COMMUNITY_ENDPOINTS from './endpoints';

const USERS_BASE_URL = COMMUNITY_ENDPOINTS.ADMIN.USERS;

export const getUsers = (params = {}) =>
  communityHttpClient.get(`${USERS_BASE_URL}/`, { params });

export const performUserAction = (userId, action, data = {}) =>
  communityHttpClient.post(`${USERS_BASE_URL}/${userId}/${action}/`, data);

export const users = {
  getAll: getUsers,
  performAction: performUserAction
};

export default {
  users
};
